import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const ImportUploader = ({ onFileUpload }) => {
    const onUploadChange = ({ file }) => onFileUpload(file);

    return (
        <Upload.Dragger
            name="import"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={onUploadChange}
            beforeUpload={() => false}
            style={{ height: '50vh' }}
        >
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">
                Click or drag spreadsheet file to this area to upload.
                <br />
                <br />
                The required format for periods in the file:
                <br />
                Month: yyyy-[number]
                <br />
                Quarter: yyyy-Q[number]
                <br />
                Year: yyyy
                <br />
                <br />
            </p>
            <p className="ant-upload-hint">Supports only single spreadsheet upload.</p>
        </Upload.Dragger>
    );
};

export default ImportUploader;
